module.exports = __webpack_public_path__ + "2cbde78c0522c1d41b235c2ce36abf45.pdf";